<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'GENERATE-INVOICE'" [breadcrumb]="''" [count]=""
    icon="fa-money-bill">
</app-breadcrumb>

<form novalidate [formGroup]="generateForm" class="k-form" *ngIf="loaded">
    <div class="mt-2 ml-3 mr-3 pt-3 pl-3 pr-3">
        <div class="row">
            <div class="col-1 pt-3">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark" [ngClass]="{'k-disabled': !isAdmin}">
                        {{ 'ALL' | translate }}
                    </span>
                    <input type="checkbox" [indeterminate]="allPayersCheckbox.value === null"
                        formControlName="allPayersCheckbox" kendoCheckBox />
                </label>
            </div>
            <div class="col-5">
                <label for="payers" class="k-form-field w-100"
                    [ngClass]="{'k-disabled': allPayersCheckbox && allPayersCheckbox.value}">
                    <span class="k-text-uppercase dark">
                        {{ 'PAYER-NAME' | translate }} *
                    </span>
                    <kendo-multiselect [data]="payersFiltered" formControlName="payers" class="max-height"
                        [textField]="'name'" [filterable]="true" [valueField]="'id'"
                        (filterChange)="handlePayerFilter($event)" (close)="searchTerm=''" [autoClose]="true"
                        [virtual]="virtualFeeSchedule" [itemDisabled]="payerItemDisabled">
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                            </span>
                        </ng-template>
                    </kendo-multiselect>
                </label>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="payers.hasError('required') && payers.touched">
                    <span>{{'REQUIRED-PAYER-NAME' | translate}}</span>
                </div>
            </div>
            <div class="col-6">
                <label for="feeSchedules" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{'FEE-SCHEDULE' | translate}} *
                    </span>
                    <kendo-multiselect id="feeSchedules" [data]="feeSchedulesFiltered" formControlName="feeSchedules"
                        [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                        (filterChange)="filterFeeSchedules($event)" (close)="searchTerm=''" [autoClose]="true"
                        [virtual]="virtualFeeSchedule">
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                            </span>
                        </ng-template>
                    </kendo-multiselect>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="feeSchedules.hasError('required') && feeSchedules.touched">
                        {{'REQUIRED-FEE-SCHEDULE' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <kendo-daterange>
                    <div class="k-form-field w-100" style="height:100px">
                        <kendo-floatinglabel text="{{'FROM' | translate}} *" class="k-text-uppercase dark"
                            style="margin-right: 15px;">
                            <kendo-dateinput kendoDateRangeStartInput formControlName="fromDateSelection">
                            </kendo-dateinput>
                        </kendo-floatinglabel>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="fromDateSelection.hasError('required') && (fromDateSelection.touched || toDateSelection.touched)">
                            {{'REQUIRED-FROM' | translate}}
                        </div>
                    </div>
                    <div class="k-form-field w-100" style="height:100px">
                        <kendo-floatinglabel text="{{'TO' | translate}} *" class="k-text-uppercase dark"
                            style="position: relative; left: 7px;">
                            <kendo-dateinput kendoDateRangeEndInput formControlName="toDateSelection" [max]="maxDate">
                            </kendo-dateinput>
                        </kendo-floatinglabel>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="toDateSelection.hasError('required') && (fromDateSelection.touched || toDateSelection.touched)">
                            {{'REQUIRED-TO' | translate}}
                        </div>
                    </div>
                </kendo-daterange>
            </div>
        </div>
        <div class="float-right mb-3">
            <button appPreventClick class="k-button k-primary" [disabled]="!generateForm.valid || !generateForm.dirty"
                (click)="process($event)">{{ 'PROCESS' | translate }}<i
                    class="fa fa-plus fa-lg fa-fw fa-search-icon"></i>
            </button>
        </div>
    </div>
</form>